import { ReactNode } from 'react';
import { FlagIcon } from '@/components/icons/FlagIcon';
import { FILTER_DISPLAY_LIMIT } from '@/components/radar/filterSummaries/RadarFilterSummaryItem';
import { BaseOption } from '@/types/generic';
import { hasCountryCode } from '@/utils/predicates';

export type BioDataItem = {
  id?: string;
  label: string;
  value: string | ReactNode;
  comparisonValue?: string | ReactNode;
};

export const BioTableContent = ({ options }: { options: BaseOption<unknown>[] }) => {
  const showExtraCount = options.length > FILTER_DISPLAY_LIMIT;
  const displayOptions = options.slice(0, FILTER_DISPLAY_LIMIT);
  const hasFlags = options.some(opt => hasCountryCode(opt.optional));

  if (!hasFlags) {
    const labels = displayOptions.map(({ label }) => label).join(', ');
    const text = showExtraCount ? `${labels} +${options.length - FILTER_DISPLAY_LIMIT}` : labels;
    return <div className="whitespace-normal">{text}</div>;
  }

  return (
    <div className="flex gap-x-2 flex-wrap">
      {displayOptions.map(({ label, value, optional }) => (
        <div className="flex gap-x-2 items-center" key={`${label}-${value}`}>
          {hasCountryCode(optional) && <FlagIcon countryCode={optional.countryCode} />}
          {label}
        </div>
      ))}
      {showExtraCount && <span className="flex items-center">+{options.length - FILTER_DISPLAY_LIMIT}</span>}
    </div>
  );
};

export const createPlaceholderData = (length: number): BioDataItem[] =>
  Array.from({ length }, (_, i) => ({
    id: `row-${i}`,
    label: '-',
    value: '-',
  }));
